<template lang="pug">
.search-result
  template(v-if="Object.keys(results).length > 0")
    ul
      template(v-for="item in results")
        template(v-if="isDataExists(item)")
          li(@click="selectedSearch(item)")
            .game-type
              img(:src="'/images/icon-sport-svg/' + getSportsImage(item[2])")
            .game-name
              span(v-if="league && league[item[1]]") {{ league[item[1]][4] }}
            .team
              span {{ item[5] }}
              template(v-if="item[5]!=item[6]")
                span.ml-1.text-lowercase -vs-
                span.ml-1 {{ item[6] }}
            .row
              .col-6
                span.day(v-if="[1,2,3,4].includes(item[4])") {{ getMarket(item[4]) }}
              .col-6.text-right
                span.time {{ $dayjs(item[8]).format("MM/DD/YYYY hh:mm A") }}
  template(v-else)
    .no-data
      .no-data-wrapper
        img(src='/images/no_data.svg?v=12')
        span.text {{ $t("ui.no_record") }}
    //- .message.dark
    //-   .empty.text-center
    //-     i.fad.fa-exclamation-triangle
    //-   p.no-message.text-center.text-dark {{ $t("message.no_information_available") }}

</template>

<script>
import config from "@/config";
import { EventBus } from "@/library/_event-bus.js";

export default {
  components: {},
  props: {
    results: {
      type: Object
    }
  },
  computed: {
    search() {
      return this.$store.getters.search;
    },
    league() {
      return this.$store.getters.data.league;
    }
  },
  methods: {
    getSportsImage(e) {
      return config.getSportsImage(e);
    },
    isDataExists(e) {
      if (this.search == null || this.search == "") {
        return false;
      }
      if(this.league && this.league[e[1]] && this.league[e[1]][5] == 1) {
        var ln = this.league[e[1]][4].toLowerCase();
        var th = e[5].toLowerCase();
        var ta = e[6].toLowerCase();
        var s = this.search.toLowerCase();
        if (ln.includes(s)) return true;
        if (th.includes(s)) return true;
        if (ta.includes(s)) return true;
      }

      return false;
    },
    getMarket(e) {
      var result = "";
      switch (e) {
        case 1:
          result = this.$t("ui.early");
          break;
        case 2:
          result = this.$t("ui.today");
          break;
        case 3:
          result = this.$t("ui.live");
          break;
        case 4:
          result = this.$t("ui.parlay");
          break;
      }

      return result;
    },
    selectedSearch(e) {
      if ([1].includes(e[4])) {
        var day = Math.abs(this.$dayjs().diff(this.$dayjs(e[8]).add(12, 'hour'), 'day'));
        if(day > 7) {
          this.$store.dispatch("layout/setSelectedDays", "0");
        } else {
          this.$store.dispatch("layout/setSelectedDays", day.toString());
        }
      }
      this.$store.dispatch("layout/setSelectLeague", [e[1]]);
      this.$store.dispatch("layout/setSelectedMatch", e[0]);
      $("#search-modal").fadeOut();
      $("body").removeClass("snapjs-left");
      var mi5 = {};
      mi5["menuX"] = false;
      mi5["menuY"] = "0";
      mi5["menu0"] = "all";
      mi5["menu1"] = ([1,2,4].includes(e[4])) ? ([1].includes(e[4])) ? "early" : "today" : "live";
      mi5["menu2"] = e[2];
      mi5["menu3"] = (e[5] == e[6] && ![40].includes(e[2])) ? "orz" : "hdpou";
      this.$store.dispatch("layout/setMenuItems", mi5);
      EventBus.$emit("INVALIDATE", mi5);
      this.$router.push("/prematch").catch(err => {});
    }
  }
};
</script>
